import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterReducerState, SerializedRouterStateSnapshot } from '@ngrx/router-store';

const getPathParamOfRouteSnapshot = (snapshot: ActivatedRouteSnapshot, paramName: string): string | null => {
  if (snapshot.children.length > 0) {
    for (const child of snapshot.children) {
      const result = getPathParamOfRouteSnapshot(child, paramName);
      if (result) {
        return result;
      }
    }
  }

  return snapshot.params[paramName] || null;
};

export const getPathParamOfRoute = (routerState: RouterReducerState<SerializedRouterStateSnapshot>, paramName: string): string | null => {
  return getPathParamOfRouteSnapshot(routerState.state.root, paramName);
};
